var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0.150391C6.13184 0.150391 6.64444 0.662126 6.64453 1.29395V4.35547H9.70605C10.3379 4.35556 10.8496 4.86816 10.8496 5.5C10.8496 6.13184 10.3379 6.64444 9.70605 6.64453H6.64453V9.70605C6.64444 10.3379 6.13184 10.8496 5.5 10.8496C4.86816 10.8496 4.35556 10.3379 4.35547 9.70605V6.64453H1.29395C0.662126 6.64444 0.150391 6.13184 0.150391 5.5C0.150391 4.86816 0.662126 4.35556 1.29395 4.35547H4.35547V1.29395C4.35556 0.662126 4.86816 0.150391 5.5 0.150391Z",
    fill: "#8E8E93",
    stroke: "#ECECF1",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/icon-plus.5aeba054c6e40f941308001631faf78d.svg";
export { ForwardRef as ReactComponent };